import { render, staticRenderFns } from "./PositionalAudio.vue?vue&type=template&id=55ab3167&"
import script from "./PositionalAudio.vue?vue&type=script&lang=js&"
export * from "./PositionalAudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports